import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable({
  providedIn: 'root'
})
export class CustomerWizardService extends RestfulService<Models.CustomerWizardData> {

  constructor(public restService: RestService) {
    super(Models.CustomerWizardData);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('customer-wizard-datas');
  }
}
